import moment from 'moment';
import { compose, hoistStatics, withHandlers, lifecycle, withProps, withState } from 'recompose';
import { withRouter } from 'react-router-dom';
import { toast } from 'react-toastify';
import Subscriber from './Subscriber';
import fh from '../../../helpers/form.helper';
import ModelService from '../../../services/subscriber.service';
import CardLoading from '../../../components/CardLoading';
import WithLoading from '../../../components/WithLoading';
import canUpdate from '../../../components/cms/permissions/CanUpdate';
import ExtModuleService from '../../../services/extModule.service';

const defaultFormData = {
  username: '',
  first_name: '',
  last_name: '',
  email: '',
  name: '',
  title: '',
  address: '',
  phone: '',
  status: ModelService.STATUS_PENDING,
};

const onSubmit = props => redirect => async (event) => {
  const { isNewModel, history, formData, t } = props;
  await fh.beforeSave(event, props, redirect);
  const { model, errors } = await ModelService.update(formData);

  if (!errors) {
    if (redirect) {
      return history.push(ModelService.baseRoute);
    }
    if (isNewModel) return history.push(ModelService.getUpdateUrl(model.id));
    await applyModel(props.setFormData, model);
    fh.notify(t);
  }
  props.setErrors(!errors ? {} : errors);
  return props.setIsSubmitting(false);
};
const start = (props) => async () => {
  const { model } = await ModelService.start(props.formData.id);
  await props.setFormData({
    ...props.formData,
    status: model.status
  })
};

const deploy = (props) => async () => {
  const { model } = await ModelService.start(props.formData.id);
  await props.setFormData({
    ...props.formData,
    status: model.status
  });

  toast.info('Please wait 3-5 minutes and then update this page');
};

const stop = (props) => async () => {
  const { model } = await ModelService.stop(props.formData.id);
  await props.setFormData({
    ...props.formData,
    status: model.status
  })
};

const applyModel = async (setFormData, model) => {
  await setFormData({
    ...defaultFormData,
    ...model,
    modules: model.modules ? model.modules.map(item => ({ value: item.id, label: item.name })) : []
  });
};

const enhance = compose(
  withState('colors', 'setColors', []),
  withState('modules', 'setModules', []),
  ...fh.defaultRecompose(defaultFormData),
  lifecycle({
    async componentDidMount() {
      await fh.initModelData(this.props, applyModel, ModelService);
      const modules = await ExtModuleService.getAll();
      await this.props.setModules(modules)
    },
  }),
  withProps(props => ({
    title: props.t('Subscriber') + fh.getTitleEnd(props),
    statusList: ModelService.getStatusOptions(props.t),
    paymentStatusList: ModelService.getPaymentStatusOptions(props.t),
    paymentTypesList: ModelService.getPaymentTypesOptions(props.t),
    showTrialEndDate: props.formData &&
      props.formData &&
      props.formData.payment_status &&
      Number(props.formData.payment_status) === ModelService.PAYMENT_STATUS_TRAIL &&
      props.formData.trial_expired_at &&
      moment(props.formData.trial_expired_at).isValid(),
  })),
  withHandlers({
    onSubmit,
    onChange: fh.onChangeFormDataElement,
    start,
    stop,
    deploy
  }),
);

export default canUpdate(ModelService)(withRouter(hoistStatics(enhance)(WithLoading(Subscriber, CardLoading))));



// WEBPACK FOOTER //
// ./src/views/subscribers/subscriber/index.js